import { createConnectTransport } from "@connectrpc/connect-web";
import { createClient, type Client } from "@connectrpc/connect";
import {
  CATApp,
  AppRoles,
} from "@anu-its/cat-grpc-pb/js/anu/cat_app/cat_app_pb";
import { env } from "./env";
import { authInterceptor } from "@/app/providers/Interceptors";

const transport = createConnectTransport({
  baseUrl: env.NEXT_PUBLIC_API_BASE_URL,
  interceptors: [authInterceptor],
});

const catAppAPIClient: Client<typeof CATApp> = createClient(CATApp, transport);

const appRolesAPIClient: Client<typeof AppRoles> = createClient(
  AppRoles,
  transport,
);

export { catAppAPIClient, appRolesAPIClient };
